<template>
  <div class="product align-center w-100 pb20">
    <div class="block no-underline product-link"
         @click="clickToClose"
    >
      <router-link class="no-underline"
                   :to="productLink"
                   data-testid="productLink"
      >
        <div class="product-image relative"
             :class="[{ sale: labelsActive && isOnSale }, { new: labelsActive && isNew }]"
        >
          <product-image-slider class="product-image__content"
                                :image="thumbnailObj"
                                :key="product.sku"
                                :alt="product.name | htmlDecode"
                                data-testid="productImage"
                                v-if="currentPartner && currentPartner.hasOwnProperty('display_mode') && currentPartner.display_mode === 'shop'"
          />
          <product-image :image="thumbnailObj"
                         :key="product.sku"
                         :alt="product.name | htmlDecode"
                         data-testid="productImage"
                         v-else
          />
        </div>
        <div class="additinal-wrap start-xs">
          <price :product="product" :qty="1" />
          <p class="mb0 cl-accent mt0 w-100 product-name" v-if="!onlyImage">
            {{ product.name | htmlDecode }}
          </p>
          <div class="weight pt10 start-xs" v-if="product.weight">
            <span>{{ product.weight | toWeight }}</span>
          </div>
        </div>
      </router-link>
    </div>
    <mini-open-configurator v-if="product.custom_options && product.custom_options.length > 0
      && product.custom_options.filter(option => option.is_active === 1).length
      && isCheckoutAllowed && activeButtonAddToCart"
      class="col-xs-12 col-sm-4 col-md-6"
      :product="product"
    />
    <mini-add-to-cart v-else-if="isCheckoutAllowed && activeButtonAddToCart" class="col-xs-12 col-sm-4 col-md-6" :product="product"/>
  </div>
</template>

<script async>
import config from 'config'
import rootStore from '@vue-storefront/core/store'
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile.ts'
import { canShowSpecialPriceForProduct } from '@vue-storefront/core/modules/catalog/helpers/tax'
import { mapGetters } from 'vuex'

const Price = () => import(/* webpackChunkName: "vsf-price" */ 'theme/components/core/blocks/Product/Price.vue');
const ProductImage = () => import(/* webpackChunkName: "vsf-product-image" */ 'theme/components/core/ProductImage');
const ProductImageSlider = () => import(/* webpackChunkName: "vsf-product-image-slider" */ 'theme/components/core/ProductImageSlider');
const MiniOpenConfigurator = () => import(/* webpackChunkName: "vsf-mini-open-configurator" */ 'theme/components/core/MiniOpenConfigurator');
const MiniAddToCart = () => import(/* webpackChunkName: "vsf-mini-add-to-cart" */ 'theme/components/core/MiniAddToCart');

export default {
  mixins: [ProductTile],
  components: {
    ProductImageSlider,
    MiniAddToCart,
    MiniOpenConfigurator,
    ProductImage,
    Price
  },
  props: {
    labelsActive: {
      type: Boolean,
      default: true
    },
    onlyImage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canShowSpecialPrice () {
      return canShowSpecialPriceForProduct(this.product)
    },
    thumbnailObj () {
      return {
        src: this.thumbnail,
        loading: this.placeholder
      }
    },
    cartItem () {
      return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    qtyInCart () {
      if (this.cartItem) {
        return this.cartItem.qty
      }
    },
    activeButtonAddToCart () {
      if (this.product.partner && this.product.partner.active && this.product.partner.enabled) {
        return this.product.partner.active && this.product.partner.enabled
      }
      return this.currentPartner.active && this.currentPartner.enabled
    },
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    isCheckoutAllowed () {
      return (this.currentLocation.hasOwnProperty('is_checkout_allowed')) ? this.currentLocation.is_checkout_allowed : true
    }
  },
  methods: {
    onProductPriceUpdate (product) {
      if (product.sku === this.product.sku) {
        Object.assign(this.product, product)
      }
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        if (config.products.configurableChildrenStockPrefetchDynamic && rootStore.products.filterUnavailableVariants) {
          const skus = [this.product.sku]
          if (this.product.type_id === 'configurable' && this.product.configurable_children && this.product.configurable_children.length > 0) {
            for (const confChild of this.product.configurable_children) {
              const cachedItem = rootStore.state.stock.cache[confChild.id]
              if (typeof cachedItem === 'undefined' || cachedItem === null) {
                skus.push(confChild.sku)
              }
            }
            if (skus.length > 0) {
              rootStore.dispatch('stock/list', { skus: skus }) // store it in the cache
            }
          }
        }
      }
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-priceupdate', this.onProductPriceUpdate)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-priceupdate', this.onProductPriceUpdate)
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/animations/transitions';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

$bg-secondary: color(secondary, $colors-background);
$border-secondary: color(secondary, $colors-border);
$color-white: color(white);

.product {
  @media (max-width: 768px) {
    padding-bottom: 10px;
  }
}
.additinal-wrap{
    color: #111;
   .price{
       font-weight: bold;
       color: #111;
           @media (max-width: 768px) {
               font-size: 14px;
           }
       }
    .product-name{
        overflow: hidden;
        word-wrap: break-word;
        text-wrap: pretty;
        line-height: 1.5em;
        height: 3em;
    }
        @media (max-width: 768px) {
            font-size: 13px;
        }
    }

.price-original {
  text-decoration: line-through;
}
.price-special {
  color: #11bb2e!important;
}
.black{
    color: #000;
}
%label {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: $border-secondary;
  text-transform: uppercase;
  color: $color-white;
  font-size: 12px;
}

.product-image{
  overflow: hidden;
  width:100%;
  height: 100%;
  max-height: 300px;
  background-color: #fff;

  &:hover{
    .product-image__content{
      opacity: 1;
      transform: scale(1.1);
    }
    &.sale::after,
    &.new::after{
      opacity: 1;
    }
  }
  &__content{

    padding-bottom: calc(300% / (257 / 100));
    mix-blend-mode: darken;
    opacity: 1;
    transform: scale(1);
    will-change: transform;
    transition: .3s opacity $motion-main, .3s transform $motion-main;
    @media (min-width: 769px) {
      padding-bottom: calc(208% / (168 / 100));
    }
    @media (min-width: 1200px) {
      padding-bottom: calc(300% / (276 / 100));
    }
  }

  &.sale{
    &::after {
      @extend %label;
      content: 'Sale';
    }
  }
  &.new{
    &::after {
      @extend %label;
      content: 'New';
    }
  }
}

.weight {
  min-height: 30px;
  box-sizing: border-box;
  font-size: 16px;
  color: #666;
}
</style>

<style lang="scss">
.additinal-wrap {
  .price {
    > div {
      flex-direction: column;

      .price-original {
        font-size: 16px;
      }
    }
  }
}
</style>
